"use client"

import { create } from "zustand"
import { persist } from "zustand/middleware"

interface UserRatingsStore {
  ratings: Record<string, number> // key: `${site}-${postId}`, value: 1-5 stars
  downloads: Record<string, number> // key: `${site}-${postId}`, value: download count
  setRating: (site: string, postId: string, rating: number) => void
  getRating: (site: string, postId: string) => number
  recordDownload: (site: string, postId: string) => void
  getDownloadCount: (site: string, postId: string) => number
}

export const useUserRatingsStore = create<UserRatingsStore>()(
  persist(
    (set, get) => ({
      ratings: {},
      downloads: {},

      setRating: (site: string, postId: string, rating: number) => {
        const key = `${site}-${postId}`
        set((state) => ({
          ratings: {
            ...state.ratings,
            [key]: rating,
          },
        }))
      },

      getRating: (site: string, postId: string) => {
        const key = `${site}-${postId}`
        return get().ratings[key] || 0
      },

      recordDownload: (site: string, postId: string) => {
        const key = `${site}-${postId}`
        set((state) => ({
          downloads: {
            ...state.downloads,
            [key]: (state.downloads[key] || 0) + 1,
          },
        }))
      },

      getDownloadCount: (site: string, postId: string) => {
        const key = `${site}-${postId}`
        return get().downloads[key] || 0
      },
    }),
    {
      name: "user-ratings",
    },
  ),
)
